import React, { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import '../ficha-master.css';
import Api from '../../../../api/global.service.js';
import Swal from 'sweetalert2';

const ModalFichaMasterEditar = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);
  const [blocking, setBlocking] = useState(false);
  const [error, setError] = useState('');
  const [ficha, setFicha] = useState(null);
  const fileInputRef = useRef(null);

  useImperativeHandle(ref, () => ({
    show: showHandler,
    setData: (data) => setFicha(data),
  }));

  const showHandler = () => {
    setError('');
    if (fileInputRef.current) fileInputRef.current.value = '';
    setShow(true);
  };

  const closeHandler = () => {
    setShow(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const file = fileInputRef.current?.files[0];
    if (!file) {
      setError('Por favor selecciona un archivo xlsx.');
      return;
    }

    const formData = new FormData();
    formData.append('archivo', file);
    formData.append('valida_mysql_config', 0);
    formData.append('valida_rpt_config', 0);

    setError('');
    setBlocking(true);

    Api.createMultiPart(
      `ficha/kobo/master/agregaPreguntas/${ficha.id_kobo_ficha_principal}`,
      formData
    )
      .then(() => {
        setBlocking(false);
        closeHandler();
        Swal.fire({
          icon: 'success',
          title: 'Actualización exitosa',
          text: 'Las preguntas del Master fueron actualizadas correctamente.',
          confirmButtonColor: '#28a745',
        });
      })
      .catch((err) => {
        setBlocking(false);
        const msg =
          err?.response?.data?.message || 'Ocurrió un error al procesar el archivo.';
        setError(msg);
      });
  };

  return (
    <div
      className="modal"
      style={{
        display: show ? 'block' : 'none',
        backgroundColor: 'rgba(0,0,0,0.2)',
      }}
    >
      <div className="modal-dialog" style={{ width: 500 }}>
        <div className="modal-content">
          <div className="modal-header" style={{ flex: 'inherit' }}>
            <h4 className="modal-title">{props.title}</h4>
            <button
              onClick={closeHandler}
              type="button"
              className="btn"
              style={{ borderRadius: '20px 20px 20px 20px' }}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            {ficha && (
              <p className="m-b-15">
                <strong>Ficha:</strong> {ficha.nombre}
              </p>
            )}

            <div className="m-b-20" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: 4, padding: '12px 16px', fontSize: 13 }}>
              <p style={{ fontWeight: 600, marginBottom: 6 }}>Instrucciones:</p>
              <ul style={{ paddingLeft: 18, marginBottom: 10 }}>
                <li>Descarga el master con la información de "Incluir configuraciones".</li>
                <li>Agrega las variables nuevas en el lugar correspondiente.</li>
                <li>Dejar la columna de <code>config_id</code> en blanco para la variable nueva.</li>
              </ul>
              <p style={{ fontWeight: 600, marginBottom: 4 }}>NOTAS:</p>
              <ul style={{ paddingLeft: 18, marginBottom: 10 }}>
                <li>Este elemento NO es para editar o mover de lugar variables. Para ello contactar al equipo dev.</li>
                <li>Si las variables se necesitan agregar a MySQL, llenar las columnas de <code>config_tabla</code>	y <code>config_columna</code> con el nombre de la tabla y columna de la variable.</li>
              </ul>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group m-b-15">
                <label>Archivo xlsx</label>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".xlsx"
                  className="form-control"
                />
              </div>

              {error && (
                <div className="form-group m-b-15">
                  <span style={{ color: 'red' }}>{error}</span>
                </div>
              )}

              {blocking ? (
                <p>Procesando...</p>
              ) : (
                <button
                  type="submit"
                  className="btn btn-sirio"
                  style={{ borderRadius: '20px 20px 20px 20px' }}
                >
                  <i className="fa fa-upload"></i> Cargar archivo
                </button>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ModalFichaMasterEditar;
